import { IController, IComponentOptions } from "angular";

export class FormCtrl implements IController {
  screen: "session" | "objective" | "kr";
}

export const FormComponent: IComponentOptions = {
  controller: FormCtrl,
  templateUrl: require("./form.jade"),
  transclude: true,
  bindings: {
    screen: "@",
  },
};
